exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ontology-search-container[data-v-56df26a6]{height:100%}", ""]);

// exports
